<div class="modal-header">
  <img [src]="imgSrc" alt="Paste" width="30px">
  <h5 class="modal-title">Paste Text</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body text-center">
  <div id="paste-area" contenteditable="true" onbeforeinput="return false">
    <p>
      Press <kbd *ngIf="!isMacOS; else macOS" spellcheck="false">Ctrl</kbd> + <kbd>V</kbd> or right-click here and
      select <strong>Paste</strong>.
    </p>
    <ng-template #macOS>
      <kbd>⌘</kbd>
    </ng-template>
    <p>Once you paste the content, this dialog will close automatically.</p>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cancel</button>
</div>